<p-chart type="line" [data]="donneegraphe" width="400" height="400" (onDataSelect)="selectData($event)"></p-chart>
